import { useState } from "react";
import { Outlet } from "react-router-dom";

import { Grid, makeStyles } from "@material-ui/core";

import { Header } from "./Header";
import { PAGES } from "../../pages";
import { LeftNav } from "./LeftNavigator";
import NoiIcon from "../../assets/images/icons/nav/noi.svg";
import AssetsIcon from "../../assets/images/icons/nav/assets.svg";
import RevenuesIcon from "../../assets/images/icons/nav/revenues.svg";
import DashboardIcon from "../../assets/images/icons/nav/dashboard.svg";
import EmissionsIcon from "../../assets/images/icons/nav/emissions.svg";
import UnrealizedIcon from "../../assets/images/icons/nav/unrealized.svg";
import ReportsIcon from "../../assets/images/icons/nav/reports.svg";
import NoiIconSelected from "../../assets/images/icons/nav/noi-selected.svg";
import AssetsIconSelected from "../../assets/images/icons/nav/assets-selected.svg";
import RevenuesIconSelected from "../../assets/images/icons/nav/revenues-selected.svg";
import EmissionsIconSelected from "../../assets/images/icons/nav/emissions-selected.svg";
import DashboardIconSelected from "../../assets/images/icons/nav/dashboard-selected.svg";
import UnrealizedIconSelected from "../../assets/images/icons/nav/unrealized-selected.svg";
import ReportsIconSelected from "../../assets/images/icons/nav/reports-selected.svg";
import { COLORS } from "../../theme/colors";

const NAV_ITEMS = [
  {
    icon: DashboardIcon,
    iconSelected: DashboardIconSelected,
    text: "Dashboard",
    path: PAGES.dashboard.index,
    id: "dashboard-nav",
  },
  {
    icon: RevenuesIcon,
    iconSelected: RevenuesIconSelected,
    text: "Power Rev.",
    path: `${PAGES.dashboard.index}/${PAGES.dashboard.powerRevenues}`,
    id: "power-rev-nav",
  },
  {
    icon: EmissionsIcon,
    iconSelected: EmissionsIconSelected,
    text: "Emission",
    path: `${PAGES.dashboard.index}/${PAGES.dashboard.carbonImpact}`,
    id: "emission-nav",
  },
  {
    icon: NoiIcon,
    iconSelected: NoiIconSelected,
    text: "NOI",
    path: `${PAGES.dashboard.index}/${PAGES.dashboard.noi}`,
    id: "noi-nav",
  },
  {
    icon: UnrealizedIcon,
    iconSelected: UnrealizedIconSelected,
    text: "Unrealized",
    path: `${PAGES.dashboard.index}/${PAGES.dashboard.unrealized}`,
    id: "unrealized-nav",
  },
  {
    icon: AssetsIcon,
    iconSelected: AssetsIconSelected,
    text: "Power Assets",
    path: `${PAGES.dashboard.index}/${PAGES.dashboard.powerAssets}`,
    id: "power-assets-nav",
  },
  {
    icon: ReportsIcon,
    iconSelected: ReportsIconSelected,
    text: "Reports",
    id: "reports-nav",
  },
];

const useStyles = makeStyles(() => ({
  content: {
    flexGrow: 1,
  },
}));

export const DashboardLayout = () => {
  const classes = useStyles();
  const [collapsed, setCollapsed] = useState(true);
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Header onHoverLogo={() => setCollapsed(!collapsed)} />
      <Grid className={classes.content} container style={{ flexWrap: "nowrap", overflow: "auto" }}>
        <Grid item>
          <LeftNav collapsed={collapsed} navItems={NAV_ITEMS} />
        </Grid>

        <Grid item style={{ flexGrow: 1, overflow: "auto", backgroundColor: COLORS.cultured }}>
          <Outlet />
        </Grid>
      </Grid>
    </div>
  );
};
